export enum SQRL_EVENT {
  SEARCH_CLOSE = "squirrel.search.close",
  SEARCH_OPEN = "squirrel.search.open",
  SEARCH_HIDE = "squirrel.search.hide",
  SEARCH_FOCUS = "squirrel.search.focus",
}

export enum SEARCH_BOX_ACTION {
  CLICK = "click",
  CHAR = "character",
}
